<template>
  <v-row>
    <v-col cols="12">
      <h2>Recent Billing Runs</h2>

    </v-col>

    <v-col cols="12">
      <v-card>
        <v-card-title>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="developmentData.approvals"
          :search="search"
          item-key="name"
          class="elevation-1"
        >
          <template #item.approval_file="{ value, item }">
            <v-btn
              v-if="value"
              x-small
              :loading="downloadLoading"
              :disabled="downloadLoading"
              color="blue-grey"
              class="ma-2 white--text"
              fab
              @click="downloadApproval(item.id, value)"
            >
              <v-icon dark>
                mdi-cloud-download
              </v-icon>
            </v-btn>
          </template>

          <template #item.paper_file="{ value, item }">
            <v-btn
              v-if="value"
              x-small
              :loading="downloadLoading"
              :disabled="downloadLoading"
              color="blue-grey"
              class="ma-2 white--text"
              fab
              @click="downloadPaper(item.id, value)"
            >
              <v-icon dark>
                mdi-cloud-download
              </v-icon>
            </v-btn>
          </template>

          <template #item.paperless_file="{ value, item }">
            <v-btn
              v-if="value"
              x-small
              :loading="downloadLoading"
              :disabled="downloadLoading"
              color="blue-grey"
              class="ma-2 white--text"
              fab
              @click="downloadPaperless(item.id, value)"
            >
              <v-icon dark>
                mdi-cloud-download
              </v-icon>
            </v-btn>
          </template>

          <template #item.approval_type="{ value }">
            <v-chip
              :color="getBillType(value, 'color')"
              dark
              small
            >
              {{ getBillType(value, 'name') }}
            </v-chip>
          </template>

          <template #item.state="{ value }">
            <v-chip
              :color="getBillState(value, 'color')"
              dark
              small
            >
              {{ getBillState(value, 'name') }}
            </v-chip>


          </template>

          <template #item.bill_count="{ value, item }">
            <div>
              {{ value }} bill(s)
              <v-chip
                v-if="item.credit_count > 0"
                color="grey"
                dark
                small
              >
                {{ item.credit_count }} credited
              </v-chip>
            </div>

          </template>

        </v-data-table>
      </v-card>
    </v-col>


  </v-row>
</template>

<script>
import {get} from "vuex-pathify";
import {creditBilling} from "@/mixins/credit-billing";
import {dataTables} from "@/mixins/data-tables";

export default {
  name: "CreditBillingBillingRuns",
  props: {
    id: String
  },
  computed: {
    developmentData: get('creditBilling/development'),
  },
  mixins: [creditBilling, dataTables],
  data: (vm) => ({
    downloadLoading: false,
    search: '',
    headers: [
      {text: 'Start', align: 'start', value: 'start', sort: (a, b) => {
          return vm.dateSort(a,b);
        }},
      {text: 'End', value: 'end', sort: (a, b) => {
          return vm.dateSort(a,b);
        }},
      {text: 'Type', value: 'approval_type'},
      {text: 'Name', value: 'type_name'},
      {text: 'State', value: 'state'},
      {text: 'Bills', value: 'bill_count'},
      {text: 'Created', value: 'created_at', sort: (a, b) => {
          return vm.dateSort(a,b);
        }},
      {text: 'Approval CSV', value: 'approval_file'},
      {text: 'Paper Bills', value: 'paper_file'},
      {text: 'Paperless Bills', value: 'paperless_file'},
    ],
  }),
  methods: {
    downloadApproval(fileRef, name) {
      const file = name + '.csv';
      this.genericDownload('download-approval', fileRef, file);
    },
    downloadPaper(fileRef, name) {
      const file = name + '.pdf';
      this.genericDownload('download-approval-paper', fileRef, file);
    },
    downloadPaperless(fileRef, name) {
      const file = name + '.pdf';
      this.genericDownload('download-approval-paperless', fileRef, file);
    },
    async genericDownload(routePath, fileRef, name) {
      this.downloadLoading = true;

      await this.triggerCreditFileDownload(routePath, fileRef, name);

      this.downloadLoading = false;
    },
    formatterDate(value, withoutTime) {
      if (!value) {
        return "";
      }
      return this.formatDate(value, true, !withoutTime);
    }
  }
}
</script>

<style scoped>

</style>
